import './select-items-error-dialog.scss'

import { defineComponent, PropType } from 'vue';
import { BModal } from 'bootstrap-vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { Item, SearchResult } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { CANCEL_ALL_SELECT_ITEM, CANCEL_ONE_SELECT_ITEM, RETRY_ALL_SELECT_ITEM, RETRY_ONE_SELECT_ITEM } from '../../events';
import { BasicItemCard } from '../../cards/item/basic-item-card';

export interface ItemSelectionFailure {
    item: Item | SearchResult,
    info?: string,
    currentlyUploading?: boolean,
}

export const SelectItemsErrorDialog = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBasicItemCard: BasicItemCard,
    },
    props: {
        itemsWhoFailed: {
            type: Array as PropType<ItemSelectionFailure[]>,
            required: true,
        },
        title: {
            type: String,
            default: "selectItemErrorDialog.title",
        },
        description: {
            type: String,
            default: "selectItemErrorDialog.description",
        },
    },
    template: require('./select-items-error-dialog.html'),
    data() {
        return {
            loadingIcon: faCircleNotch,
        }
    },
    computed: {
        someItemCurrentlyUploading(): boolean {
            return this.itemsWhoFailed.findIndex(failedItem => {
                return failedItem.currentlyUploading
            }) > -1
        },
        computedDescription(): string {
            return (this.$t(this.description as string, [this.itemsWhoFailed.length]) ?? this.description) as string
        },
    },
    methods: {
        onRetryAll() {
            this.$emit(RETRY_ALL_SELECT_ITEM)
        },
        onCancelAll() {
            this.$emit(CANCEL_ALL_SELECT_ITEM)
        },
        onRetry(index: number) {
            this.$emit(RETRY_ONE_SELECT_ITEM, index)
        },
        onCancel(index: number) {
            this.$emit(CANCEL_ONE_SELECT_ITEM, index)
        },
        onHide(event) {
            this.$emit('hidden', event)
        },
        isUploading(index: number): boolean {
            return this.itemsWhoFailed?.[index]?.currentlyUploading ?? false
        },
        closeModal() {
            (this.$refs.modal as BModal).hide()
        },
        openModal() {
            (this.$refs.modal as BModal).show()
        },
    },
})
